
export default class ControlsModel {
    constructor(parent) {
        this.parent = parent;
    }

    get comparison() {
        return this.parent.comparison;
    }

    set comparison(value) {
        this.parent.comparison = value;
    }

    set showPDF(value) {
        this.parent.showPDF = value;
    }

    get showPDF() {
        return this.parent.showPDF;
    }

    get comparisons() {
        return this.parent.comparisons;
    }

    get localName() {
        return this.parent.localName;
    }

    get pdfModel() {
        return this.parent.pdfModel;
    }
}
